module.exports = __webpack_public_path__ + "img/hello-img-skilled-worker.1811c554.png";